import api from "app/lib/api";
import endpoints from "static/endpoints";
import { getFormattedDate } from "utils/date";

export const processBulkHl7Jobs = async (jobs) => {
  const url = endpoints.hl7Job.processBulkHl7Jobs;
  const response = await api.put(url, jobs);
  return response;
};

export const fetchHL7Jobs = async (query) => {
  const { filters, sorting, page, pageSize, search } = query || {};
  let url = endpoints.hl7Job.fetchHL7Jobs;
  const queries = [];
  const pagination = `?page=${page}&pageSize=${pageSize}`;
  queries.push(pagination);

  if (search?.trim()) {
    queries.push(`search=${encodeURIComponent(search)}`);
  }

  if (filters?.length > 0) {
    const filterQueries = filters
      ?.map((filter) => {
        const { id, value } = filter;

        if (["report_date", "created_at", "updated_at", "dob"].includes(id)) {
          const formattedDate = getFormattedDate(new Date(value), "YYYY-MM-DD");
          return `${id}=${formattedDate}`;
        }

        return `${id}=${value}`;
      })
      ?.join("&");

    queries.push(filterQueries);
  }

  if (sorting?.length > 0) {
    const sortingQuery = sorting
      ?.map((sort) => {
        const { id, desc } = sort;
        const direction = desc ? "desc" : "asc";

        if (id === "name") {
          return `sort=firstName&order=${direction}&sort=lastName&order=${direction}`;
        }

        return `sort=${id}&order=${direction}`;
      })
      ?.join("");

    queries.push(sortingQuery);
  }

  const queryParam = queries.length > 0 ? queries.join("&") : "";
  url += queryParam;

  const response = await api.get(url);

  const mappedHl7JobsData = [...(response?.jobs || [])]?.map((item) => ({
    ...item,
    warning_flag: item?.warning_flag || false,
  }));

  const result = mappedHl7JobsData.length
    ? { jobs: mappedHl7JobsData, totalCount: response?.totalCount || 0 }
    : { ...response };

  return result;
};
